/**
 * CardHead — шапка мобильной карточки тарифа (иконка + заголовок/подзаголовок
 * + кнопка «Изменить»). Общая для соло- и клиника-блоков.
 */

import type {ReactNode} from 'react';

type CardHeadProps = {
  icon: ReactNode;
  iconClassName: string;
  title: string;
  subtitle: string;
  onEdit: () => void;
};

export const CardHead = ({icon, iconClassName, title, subtitle, onEdit}: CardHeadProps) => (
  <div className="flex items-center justify-between">
    <div className="flex items-center gap-[11px]">
      <div className={`grid size-[38px] place-items-center rounded-[11px] ${iconClassName}`}>
        {icon}
      </div>
      <div>
        <div className="text-[15px] font-bold">{title}</div>
        <div className="text-[11.5px] text-muted-foreground">{subtitle}</div>
      </div>
    </div>
    <button
      onClick={onEdit}
      className="h-[34px] rounded-[9px] border border-input bg-card px-[13px] text-[12.5px] font-medium text-skr-ink"
    >
      Изменить
    </button>
  </div>
);
